import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { closeCustomDialogAction } from 'redux/slices/customDialogSlice';
import { editGroupAction, getGroupAction } from 'redux/slices/groupSlice';
import GroupForm from './GroupForm';

const GroupEdit = (props) => {
    const { group, isProfile } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [groupToEdit, setGroupToEdit] = useState(null);

    useEffect(() => {
        dispatch(
            getGroupAction({
                id: group.id,
                onSuccess: (data) => setGroupToEdit(data),
            }),
        );
    }, [dispatch, group]);

    const handleSubmit = ({ data, onSuccess, onFailure }) => {
        dispatch(
            editGroupAction({
                id: group.id,
                groupDto: data,
                onSuccess: (response) => {
                    if (isProfile) {
                        setGroupToEdit(response);
                    } else {
                        dispatch(closeCustomDialogAction());
                    }
                    onSuccess(response);
                },
                onFailure: (error) => onFailure(error),
            }),
        );
    };

    if (!groupToEdit) {
        return null;
    }

    return (
        <GroupForm
            action={t('group.groupCreate.edit')}
            group={groupToEdit}
            onSubmit={handleSubmit}
            isProfile={isProfile}
        />
    );
};

export default GroupEdit;
